import { useContext } from 'preact/hooks';

import { TranslatorContext } from '../translation';

export const useTranslator = () => {
  return useContext(TranslatorContext).t;
};
